import { assign, createMachine } from 'xstate';
import { ApplicationError } from '../components/ApplicationErrorBoundary/errors/ApplicationError';
import { CredentialsEntity } from '../models/credentials';
import {
  AuthorizePayload,
  AuthorizeResponse,
  authorizeService,
  AuthorizeService,
} from './services/authorize';

type PayloadProps = {
  authorizePayload: AuthorizePayload;
};

type MachineProps = PayloadProps;
type Context = {
  credentials: CredentialsEntity | undefined;
  authorizeResponse: AuthorizeResponse | undefined;
  error: ApplicationError | undefined;
};

type Services = {
  authorize: { data: AuthorizeResponse };
};

type Events = {
  type: 'CREDENTIALS';
  payload: CredentialsEntity;
};

export const createAuthorizeMachine = (
  props: MachineProps,
  service: AuthorizeService = authorizeService
) =>
  createMachine(
    {
      context: { authorizeResponse: undefined, error: undefined, credentials: undefined },
      tsTypes: {} as import('./authorizeMachine.typegen').Typegen0,
      schema: { context: {} as Context, services: {} as Services, events: {} as Events },
      predictableActionArguments: true,
      id: 'authorizeMachine',
      initial: 'auth',
      states: {
        auth: {
          on: {
            CREDENTIALS: {
              target: 'INIT',
              actions: 'set_credentials',
            },
          },
        },
        INIT: {
          invoke: {
            src: 'authorize',
            onDone: [
              {
                actions: 'set_authorizeResponse',
                target: 'SUCCESS',
              },
            ],
            onError: [
              {
                actions: 'set_error',
                target: 'ERROR',
              },
            ],
          },
        },
        ERROR: {
          type: 'final',
        },
        SUCCESS: {
          type: 'final',
        },
      },
    },
    {
      actions: {
        set_credentials: assign({ credentials: (_, event) => event.payload }),
        set_error: assign({ error: (_, event) => event.data as ApplicationError }),
        set_authorizeResponse: assign({ authorizeResponse: (_, event) => event.data }),
      },
      services: {
        authorize: () => service.authorize(props.authorizePayload),
      },
    }
  );
